import AchievementEvent from './AchievementEvent';

export default AchievementEvent;
